import { apiPort, apiRoot, server } from './ApiConfig'
import "./Menu.css"
import React, { useState, useEffect, Suspense } from "react"
import { FaRegUser, FaInfoCircle } from 'react-icons/fa'
import axios from "axios"
import { Link, Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import { useGlobal } from './GlobalContext'
import { ReactComponent as ChangeTopicIcon } from './svg/changetopic.svg'
import { ReactComponent as NewDocIcon } from './svg/newdoc.svg'
import { ReactComponent as OpenIcon } from './svg/open.svg'
import { ReactComponent as PlayIcon } from './svg/play.svg'
import { ReactComponent as RecordIcon } from './svg/record.svg'
import { ReactComponent as SaveIcon } from './svg/save.svg'
import { ReactComponent as UserSwitchIcon } from './svg/selectuser.svg'
import { ReactComponent as SettingsIcon } from './svg/settings.svg'
import { ReactComponent as StopIcon } from './svg/stop.svg'
import { ReactComponent as TopicEditIcon } from './svg/topicedit.svg'
import { ReactComponent as ReplacementEditIcon } from './svg/replacementrules.svg'
import { ReactComponent as WavIcon } from './svg/wav.svg'
import { ReactComponent as LogoIcon } from './svg/logo.svg'
import { ReactComponent as WhatCanISayIcon } from './svg/whatcanisay.svg'
import ChangeTopic from './Topics/ChangeTopic'

const VdGrid = React.lazy(() => import('./VoxDocuments/VdGrid'));
const EditTopic = React.lazy(() => import('./Topics/EditTopic'));
const VoiceCommands = React.lazy(() => import('./Topics/VoiceCommands'));
const ReplacementEditor = React.lazy(() => import('./Topics/ReplacementEditor'));
const DictationLog = React.lazy(() => import('./Admin/DictationLog'));
const UserManagement = React.lazy(() => import('./Admin/UserManagement'));
const AdminFunctions = React.lazy(() => import('./Admin/AdminFunctions'));
const AllDocuments = React.lazy(() => import('./Admin/AllDocuments'));
const I18nView = React.lazy(() => import('./i18n/I18nView'));
const UserProfile = React.lazy(() => import('./User/UserProfile'));
const Settings = React.lazy(() => import('./Settings/Settings'));

const Menu = ({ userEmail, sessionId, userAdmin, setSessionId, setUserEmail, isLoginMode = false }) => {
  const { adminWatch, setAdminWatch } = useGlobal()
  const { userRole, setUserRole } = useGlobal()
  const { isRecording, setIsRecording } = useGlobal()
  const { isCheckingServerMessages, setIsCheckingServerMessages } = useGlobal()
  const { activeMenuItem, setActiveMenuItem, setActiveMenu } = useGlobal()
  const { isRecordingRef, selectedTopic, selectedDoc, dictateAction, setDictateAction, showEditor, setShowEditor, openDocumentAction, setOpenDocumentAction, newDocumentAction, setNewDocumentAction, replayRecognitionAction, setReplayRecognitionAction, audioDuration, isPlaying, isReplaying, saveDocumentAction, setSaveDocumentAction, documentDirty, setDocumentDirty, pendingNavigationRef, showEditor: globalShowEditor, setShowEditor: setGlobalShowEditor, documentReadOnly, setDocumentReadOnly } = useGlobal()

  const navigate = useNavigate()
  const location = useLocation()
  const [aboutPorts, setAboutPorts] = useState()
  const [showAbout, setShowAbout] = useState(false)
  const [leavePrompt, setLeavePrompt] = useState(null)

  const requestNavigate = (action) => {
    if (!documentDirty) {
      action()
      return
    }
    setLeavePrompt({ action })
  }

  const handleLeaveSave = () => {
    if (!leavePrompt) return
    pendingNavigationRef.current = leavePrompt.action
    setSaveDocumentAction(true)
    setLeavePrompt(null)
  }

  const handleLeaveDiscard = () => {
    if (!leavePrompt) return
    const action = leavePrompt.action
    setDocumentDirty(false)
    setLeavePrompt(null)
    action()
  }

  const handleLeaveCancel = () => {
    setLeavePrompt(null)
  }

  const saveDisabled = isLoginMode || isRecordingRef || documentReadOnly || !documentDirty || !selectedDoc?.uid
  const dictateDisabled = isLoginMode || documentReadOnly || !selectedTopic?.topic_id


  useEffect(() => {
    if (location.pathname === "/menu") {
      navigate("/menu/voxdocuments", { replace: true })
    }
  }, [location.pathname, navigate, userRole])

  const fetchTopics = async () => {
    try {
      const response = await axios.post(apiRoot + "api/topics/getAllTopics", { sessionId })
      if (response.data.success === false) {
        if (response.data.error === "Expired session!") {
          navigate("/login")
          alert(response.data.error || "Ismeretlen hiba történt")
          return;
        }
      }
      const topics = response.data.results.topics || []
      let portString = topics.map(item => item.port).filter(Boolean).join(', ')
      portString = apiPort + ", " + portString
      console.log("Ports:", portString)
      setAboutPorts(portString)
      setShowAbout(true)
    } catch (error) {
      console.error("Failed to fetch topics:", error)
    }
  }

  const [serverMessages, setServerMessages] = useState([])
  const [secondsLeft, setSecondsLeft] = useState(0)
  const [okButtonEnabled, setOkButtonEnabled] = useState(false)

  useEffect(() => {
    if (secondsLeft > 0) {
      const timer = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000)
      setOkButtonEnabled(false)
      return () => clearTimeout(timer)
    } else {
      setOkButtonEnabled(true)
    }
  }, [secondsLeft])

  async function fetchServerMessages() {
    try {
      const response = await axios.post(apiRoot + "api/info/getServerMessages", {
        sessionId: sessionId,
        topicId: 1,
        email: userEmail,
        buildNumber: 1,
        version: 1,
        platform: "portal",
      })
      if (response.data.success) {
        if (response.data.results.length > 0) {
          console.log("VAN SERVER MESSAGE:", response.data.results)
          setSecondsLeft(10)
          setServerMessages(response.data.results)
        }
      } else if (response.data.error === "Expired session!") {
        localStorage.removeItem("sessionId")
        navigate("/login")
      }
    } catch (error) {
      console.log("getServerMessages error!", error)
    }
  }

  useEffect(() => {
    if (isLoginMode) return
    const intervalId = setInterval(() => {
      if (!isRecording) {
        fetchServerMessages()
      }
    }, 60000)
    return () => clearInterval(intervalId)
  }, [isRecording, isLoginMode])

  const loadUserProfile = () => { }

   /*
  ██   ██ ████████ ███    ███ ██      
  ██   ██    ██    ████  ████ ██      
  ███████    ██    ██ ████ ██ ██      
  ██   ██    ██    ██  ██  ██ ██      
  ██   ██    ██    ██      ██ ███████ 
  */

  return (
    <div name="mainContainer" className={`vd-wapp ${isLoginMode ? 'vd-wapp--login' : ''}`}>
      <div className="vd-wbody">
        {/* Left Sidebar */}
          <div className={`vd-wside ${adminWatch ? "vd-wside--admin" : ""}`}>
            {/* Logo section */}
            <div style={{ marginBottom: '10px', paddingBottom: '16px', borderBottom: '1px solid var(--line)', display: 'flex', alignItems: 'center', gap: '11px' }}>
              <LogoIcon style={{ height: '21px', width: 'auto', flex: 'none' }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: '9px', lineHeight: 1 }}>
                <span style={{ width: 1, height: 16, background: 'var(--line)' }} />
                <span style={{ fontWeight: 600, fontSize: 14, color: 'var(--ink)', letterSpacing: '.2px' }}>
                  VoxDoc
                </span>
              </div>
            </div>
            
            <p style={{ fontSize: '14px', color: 'var(--muted)', marginTop: '12px' }}>{server}</p>
            <p style={{ fontSize: '12px', color: 'var(--blue-700)', marginTop: '2px' }}>{userEmail}</p>

            {/* VoxDocument Navigation */}
            <div className="vd-wgrp">
              <button
                className={`recpill ${isRecordingRef ? 'recpill--on' : ''}`}
                onClick={() => {
                  if (documentReadOnly) return
                  navigate("/menu/voxdocuments")
                  setGlobalShowEditor(true)
                  setActiveMenu("editorView")
                  if (isRecordingRef) {
                    setDictateAction('stop')
                  } else if (selectedTopic?.topic_id) {
                    setDictateAction('start')
                  }
                }}
                disabled={dictateDisabled}
                style={{ cursor: dictateDisabled ? 'not-allowed' : 'pointer', opacity: dictateDisabled ? 0.5 : 1, width: '100%' }}
              >
                <span className="recpill__icon">
                  {isRecordingRef ? (
                    <span className="recpill__rec"></span>
                  ) : (
                    <span className="recpill__ring"></span>
                  )}
                </span>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '8px' }}>
                  <span>{isRecordingRef ? "Recording" : "Dictate"}</span>
                  {selectedTopic?.name && (
                    <span style={{ fontSize: '10px', opacity: 0.8, marginTop: '0px', fontWeight: 400 }}>
                      {selectedTopic.name} model
                    </span>
                  )}
                </div>
              </button>
            </div>

            {/* Recording Navigation */}
            <div className="vd-wgrp">
              <div className="vd-wgrp__label">Recording</div>
              <button className={`vd-wnav ${activeMenuItem === "editorView" ? "vd-wnav--on" : ""}`} onClick={() => { navigate("/menu/voxdocuments"); setGlobalShowEditor(true); setActiveMenu("editorView"); }} disabled={isLoginMode || isRecordingRef} style={{ width: '233px', height: '40px', cursor: (isLoginMode || isRecordingRef) ? 'not-allowed' : 'pointer', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <RecordIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">Show Editor</span>
                {activeMenuItem === "editorView" && <div className="vd-wnav__bar"></div>}
              </button>

              <button className="vd-wnav" disabled={true} style={{ width: '233px', height: '40px', cursor: 'not-allowed', opacity: 0.5 }}>
                <div className="vd-wnav__ico">
                  <WavIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">Recognize Audio File</span>
              </button>

              <button
                className={`vd-wnav${isReplaying ? " vd-wnav--on" : ""}`}
                onClick={() => {
                  // Ensure editor route is active so VdGrid can handle replay start/stop
                  navigate("/menu/voxdocuments")
                  setGlobalShowEditor(true)
                  setActiveMenu("editorView")
                  setReplayRecognitionAction(true)
                }}
                disabled={isLoginMode || audioDuration === 0 || isRecordingRef || (!showEditor && !selectedDoc && !isReplaying)}
                style={{ width: '233px', height: '40px', cursor: (isLoginMode || audioDuration === 0 || isRecordingRef || (!showEditor && !selectedDoc && !isReplaying)) ? 'not-allowed' : 'pointer', opacity: (isLoginMode || audioDuration === 0 || isRecordingRef || (!showEditor && !selectedDoc && !isReplaying)) ? 0.5 : 1 }}
              >
                <div className="vd-wnav__ico">
                  {isReplaying ? <StopIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} /> : <PlayIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />}
                </div>
                <span className="vd-wnav__txt">{isReplaying ? "Stop Replay" : "Playback"}</span>
                {isReplaying && <div className="vd-wnav__bar"></div>}
              </button>
            </div>

            {/* Document Navigation */}
            <div className="vd-wgrp">
              <div className="vd-wgrp__label">Document</div>
              <button className={`vd-wnav ${activeMenuItem === "newDocument" ? "vd-wnav--on" : ""}`} onClick={() => requestNavigate(() => { setDocumentReadOnly(false); setAdminWatch(false); navigate("/menu/voxdocuments"); setNewDocumentAction(true); setGlobalShowEditor(true); setActiveMenu("editorView"); })} disabled={isLoginMode || isRecordingRef} style={{ width: '233px', height: '40px', cursor: (isLoginMode || isRecordingRef) ? 'not-allowed' : 'pointer', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <NewDocIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">New Document</span>
                {activeMenuItem === "newDocument" && <div className="vd-wnav__bar"></div>}
              </button>
              <button className={`vd-wnav ${activeMenuItem === "openDocument" ? "vd-wnav--on" : ""}`} onClick={() => requestNavigate(() => { setDocumentReadOnly(false); setAdminWatch(false); navigate("/menu/voxdocuments"); setOpenDocumentAction(true); setGlobalShowEditor(false); setActiveMenu("openDocument"); })} disabled={isLoginMode || isRecordingRef} style={{ width: '233px', height: '40px', cursor: (isLoginMode || isRecordingRef) ? 'not-allowed' : 'pointer', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <OpenIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">Open Document</span>
                {activeMenuItem === "openDocument" && <div className="vd-wnav__bar"></div>}
              </button>
              <button className={`vd-wnav ${activeMenuItem === "saveDocument" ? "vd-wnav--on" : ""}`} onClick={() => { if (documentReadOnly) return; setSaveDocumentAction(true); setGlobalShowEditor(true); setActiveMenu("editorView"); }} disabled={saveDisabled} style={{ width: '233px', height: '40px', cursor: saveDisabled ? 'not-allowed' : 'pointer', opacity: saveDisabled ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <SaveIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">Save Document</span>
                {activeMenuItem === "saveDocument" && <div className="vd-wnav__bar"></div>}
              </button>
            </div>

            {/* Switch Navigation */}
            <div className="vd-wgrp">
              <div className="vd-wgrp__label">Switch</div>
              <button className="vd-wnav" onClick={() => requestNavigate(() => {
                localStorage.removeItem("sessionId")
                navigate("/login")
              })} disabled={isLoginMode || isRecordingRef} style={{ width: '233px', height: '40px', cursor: (isLoginMode || isRecordingRef) ? 'not-allowed' : 'pointer', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <UserSwitchIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">Change User</span>
              </button>

              <Link to="/menu/change-topic" className={`vd-wnav ${location.pathname.endsWith("/change-topic") ? "vd-wnav--on" : ""}`} onClick={(e) => {
                if (isLoginMode || isRecordingRef || (selectedDoc && selectedDoc.document_id !== -1)) {
                  e.preventDefault()
                  return
                }
                e.preventDefault()
                requestNavigate(() => { navigate("/menu/change-topic"); setActiveMenu("changeTopic"); setGlobalShowEditor(false); })
              }} style={{ width: '233px', height: '40px', pointerEvents: (isLoginMode || isRecordingRef || (selectedDoc && selectedDoc.document_id !== -1)) ? 'none' : 'auto', opacity: (isLoginMode || isRecordingRef || (selectedDoc && selectedDoc.document_id !== -1)) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <ChangeTopicIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">Change Topic</span>
                {location.pathname.endsWith("/change-topic") && <div className="vd-wnav__bar"></div>}
              </Link>
            </div>

            {/* Context Navigation */}
            <div className="vd-wgrp">
              <div className="vd-wgrp__label">Context</div>

              <Link to="/menu/topic-editor" className={`vd-wnav ${location.pathname.endsWith("/topic-editor") ? "vd-wnav--on" : ""}`} onClick={(e) => {
                e.preventDefault()
                if (isLoginMode || isRecordingRef) return
                requestNavigate(() => { navigate("/menu/topic-editor"); setActiveMenu("topicEditor"); setGlobalShowEditor(false); })
              }} style={{ width: '233px', height: '40px', pointerEvents: (isLoginMode || isRecordingRef) ? 'none' : 'auto', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <TopicEditIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">Topic Editor</span>
                {location.pathname.endsWith("/topic-editor") && <div className="vd-wnav__bar"></div>}
              </Link>

              <Link to="/menu/replacement-editor" className={`vd-wnav ${location.pathname.endsWith("/replacement-editor") ? "vd-wnav--on" : ""}`} onClick={(e) => {
                e.preventDefault()
                if (isLoginMode || isRecordingRef) return
                requestNavigate(() => { navigate("/menu/replacement-editor"); setActiveMenu("replacementEditor"); setGlobalShowEditor(false); })
              }} style={{ width: '233px', height: '40px', pointerEvents: (isLoginMode || isRecordingRef) ? 'none' : 'auto', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <ReplacementEditIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">Replacement Editor</span>
                {location.pathname.endsWith("/replacement-editor") && <div className="vd-wnav__bar"></div>}
              </Link>
              <button className={`vd-wnav ${activeMenuItem === "voiceCommands" ? "vd-wnav--on" : ""}`} onClick={() => requestNavigate(() => { navigate("/menu/voice-commands"); setGlobalShowEditor(false); setActiveMenu("voiceCommands"); })} disabled={isLoginMode || isRecordingRef} style={{ width: '233px', height: '40px', cursor: (isLoginMode || isRecordingRef) ? 'not-allowed' : 'pointer', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <WhatCanISayIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">Voice Commands</span>
                {activeMenuItem === "voiceCommands" && <div className="vd-wnav__bar"></div>}
              </button>
            </div>

            {/* Settings Navigation */}
            <div className="vd-wgrp">
              <div className="vd-wgrp__label">Settings</div>
              <Link to="/menu/settings" className={`vd-wnav ${location.pathname.endsWith("/settings") ? "vd-wnav--on" : ""}`} onClick={(e) => {
                e.preventDefault()
                if (isLoginMode || isRecordingRef) return
                requestNavigate(() => { navigate("/menu/settings"); setActiveMenu("settings"); setGlobalShowEditor(false); })
              }} style={{ width: '233px', height: '40px', pointerEvents: (isLoginMode || isRecordingRef) ? 'none' : 'auto', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <SettingsIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                </div>
                <span className="vd-wnav__txt">Settings</span>
                {location.pathname.endsWith("/settings") && <div className="vd-wnav__bar"></div>}
              </Link>
            </div>

            {/* Admin Navigation */}
            {(userRole === "Admin" || userRole === "Partner") && (
              <div className="vd-wgrp">
                <div className="vd-wgrp__label">Admin</div>
                {userRole === "Admin" && (
                  <Link to="/menu/all-documents" className={`vd-wnav ${location.pathname.endsWith("/all-documents") ? "vd-wnav--on" : ""}`} onClick={(e) => {
                    e.preventDefault()
                    if (isLoginMode || isRecordingRef) return
                    requestNavigate(() => { navigate("/menu/all-documents"); setActiveMenu("allDocuments"); setGlobalShowEditor(false); })
                  }} style={{ width: '233px', height: '40px', pointerEvents: (isLoginMode || isRecordingRef) ? 'none' : 'auto', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                    <div className="vd-wnav__ico">
                      <OpenIcon width="20" height="20" style={{ display: "block", flex: "0 0 auto" }} />
                    </div>
                    <span className="vd-wnav__txt">All Documents</span>
                    {location.pathname.endsWith("/all-documents") && <div className="vd-wnav__bar"></div>}
                  </Link>
                )}

                {userRole === "Admin" && (
                  <Link to="/menu/dictation-log" className={`vd-wnav ${location.pathname.endsWith("/dictation-log") ? "vd-wnav--on" : ""}`} onClick={(e) => {
                    e.preventDefault()
                    if (isLoginMode || isRecordingRef) return
                    requestNavigate(() => { navigate("/menu/dictation-log"); setActiveMenu("dictationLog"); setGlobalShowEditor(false); })
                  }} style={{ width: '233px', height: '40px', pointerEvents: (isLoginMode || isRecordingRef) ? 'none' : 'auto', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                    <div className="vd-wnav__ico">
                      <FaInfoCircle size={20} />
                    </div>
                    <span className="vd-wnav__txt">Dictation Log</span>
                    {location.pathname.endsWith("/dictation-log") && <div className="vd-wnav__bar"></div>}
                  </Link>
                )}

                <Link to="/menu/user-management" className={`vd-wnav ${location.pathname.endsWith("/user-management") ? "vd-wnav--on" : ""}`} onClick={(e) => {
                  e.preventDefault()
                  if (isLoginMode || isRecordingRef) return
                  requestNavigate(() => { navigate("/menu/user-management"); setActiveMenu("userManagement"); setGlobalShowEditor(false); })
                }} style={{ width: '233px', height: '40px', pointerEvents: (isLoginMode || isRecordingRef) ? 'none' : 'auto', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                  <div className="vd-wnav__ico">
                    <FaRegUser size={20} />
                  </div>
                  <span className="vd-wnav__txt">User Management</span>
                  {location.pathname.endsWith("/user-management") && <div className="vd-wnav__bar"></div>}
                </Link>

                {userRole === "Admin" && (
                  <Link to="/menu/admin-functions" className={`vd-wnav ${location.pathname.endsWith("/admin-functions") ? "vd-wnav--on" : ""}`} onClick={(e) => {
                    e.preventDefault()
                    if (isLoginMode || isRecordingRef) return
                    requestNavigate(() => { navigate("/menu/admin-functions"); setActiveMenu("adminFunctions"); setGlobalShowEditor(false); })
                  }} style={{ width: '233px', height: '40px', pointerEvents: (isLoginMode || isRecordingRef) ? 'none' : 'auto', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                    <div className="vd-wnav__ico">
                      <FaInfoCircle size={20} />
                    </div>
                    <span className="vd-wnav__txt">Admin Functions</span>
                    {location.pathname.endsWith("/admin-functions") && <div className="vd-wnav__bar"></div>}
                  </Link>
                )}

                {userRole === "Admin" && (
                  <Link to="/menu/i18n" className={`vd-wnav ${location.pathname.endsWith("/i18n") ? "vd-wnav--on" : ""}`} onClick={(e) => {
                    e.preventDefault()
                    if (isLoginMode || isRecordingRef) return
                    requestNavigate(() => { navigate("/menu/i18n"); setActiveMenu("i18n"); setGlobalShowEditor(false); })
                  }} style={{ width: '233px', height: '40px', pointerEvents: (isLoginMode || isRecordingRef) ? 'none' : 'auto', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                    <div className="vd-wnav__ico">
                      <FaInfoCircle size={20} />
                    </div>
                    <span className="vd-wnav__txt">i18n</span>
                    {location.pathname.endsWith("/i18n") && <div className="vd-wnav__bar"></div>}
                  </Link>
                )}
              </div>
            )}

            {/* User Section */}
            <div className="vd-wgrp" style={{ marginTop: 'auto' }}>
              <div className="vd-wgrp__label">User</div>
              <Link to="/menu/user-profile" className={`vd-wnav ${location.pathname.endsWith("/user-profile") ? "vd-wnav--on" : ""}`} onClick={(e) => {
                e.preventDefault()
                if (isLoginMode || isRecordingRef) return
                requestNavigate(() => { navigate("/menu/user-profile"); setActiveMenu("userProfile"); setGlobalShowEditor(false); })
              }} style={{ width: '233px', height: '40px', pointerEvents: (isLoginMode || isRecordingRef) ? 'none' : 'auto', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <FaRegUser size={20} />
                </div>
                <span className="vd-wnav__txt">Profile</span>
                {location.pathname.endsWith("/user-profile") && <div className="vd-wnav__bar"></div>}
              </Link>
              <button className="vd-wnav" onClick={() => requestNavigate(() => fetchTopics())} disabled={isLoginMode || isRecordingRef} style={{ width: '233px', height: '40px', cursor: (isLoginMode || isRecordingRef) ? 'not-allowed' : 'pointer', opacity: (isLoginMode || isRecordingRef) ? 0.5 : 1 }}>
                <div className="vd-wnav__ico">
                  <FaInfoCircle size={20} />
                </div>
                <span className="vd-wnav__txt">About</span>
              </button>
            </div>
          </div>

        {/* Main Content Area */}
        {!isLoginMode && (
          <div className="vd-wmain">
            <Suspense fallback={<div>Betöltés...</div>}>
              <Routes>
                <Route path="/voxdocuments" element={<VdGrid sessionId={sessionId} />} />
                <Route path="/change-topic" element={<ChangeTopic sessionId={sessionId} />} />
                <Route path="/topic-editor" element={<EditTopic sessionId={sessionId} />} />
                <Route path="/replacement-editor" element={<ReplacementEditor sessionId={sessionId} topic={selectedTopic} />} />
                <Route path="/voice-commands" element={<VoiceCommands sessionId={sessionId} />} />
                <Route path="/user-profile" element={<UserProfile sessionId={sessionId} setSessionId={setSessionId} />} />
                <Route path="/dictation-log" element={<DictationLog sessionId={sessionId} />} />
                <Route path="/user-management" element={<UserManagement sessionId={sessionId} userRole={userRole} setSessionId={setSessionId} setUserEmail={setUserEmail} setUserRole={setUserRole} />} />
                <Route path="/admin-functions" element={<AdminFunctions sessionId={sessionId} userRole={userRole} setSessionId={setSessionId} setUserEmail={setUserEmail} setUserRole={setUserRole} />} />
                <Route path="/all-documents" element={<AllDocuments sessionId={sessionId} />} />
                <Route path="/i18n" element={<I18nView />} />
                <Route path="/settings" element={<Settings userEmail={userEmail} server={server} selectedTopic={selectedTopic} />} />
                <Route path="*" element={<div style={{ padding: '20px' }}>Select a function from Menu!</div>} />
              </Routes>
            </Suspense>
          </div>
        )}
      </div>

      {/* About Modal */}
      {showAbout && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full text-black">
            <h2 className="text-xl font-bold mb-4">Required ports:</h2>
            <p className="text-xl"><br />{aboutPorts}</p>
            <div className="flex justify-end mt-6">
              <button
                onClick={() => setShowAbout(false)}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Server Messages Modal */}
      {serverMessages.length > 0 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full text-black">
            <h2 className="text-xl font-bold mb-4">Server messages</h2>
            <div className="flex flex-col space-y-4 max-h-[30vh] overflow-y-auto w-full">
              {serverMessages.map((msg) => (
                <div key={msg.id || msg.message_id || msg.message} className="bg-gray-100 p-4 rounded-lg shadow hover:shadow-md transition-shadow">
                  <div className="mb-3" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "8px" }}>
                    {msg.title ? (
                      <span style={{ fontWeight: 700, fontSize: "15px", color: "#0F3F66" }}>{msg.title}</span>
                    ) : null}
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        height: "26px",
                        padding: "0 10px",
                        borderRadius: "8px",
                        background: "#D6E6F2",
                        color: "#0F3F66",
                        fontSize: "12.5px",
                        fontWeight: 700,
                        letterSpacing: "0.01em",
                      }}
                    >
                      Topic: {msg.topic_name || "All topics"}
                    </span>
                  </div>
                  <p className="text-gray-800 mb-2" style={{ whiteSpace: "pre-wrap" }}>{msg.message}</p>
                </div>
              ))}
            </div>
            <div className="flex justify-end mt-6">
              <button
                onClick={() => setServerMessages([])}
                disabled={!okButtonEnabled}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                {okButtonEnabled ? "OK" : `OK (${secondsLeft}s)`}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Unsaved changes prompt */}
      {leavePrompt && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full text-black">
            <h2 className="text-xl font-bold mb-3">Unsaved changes</h2>
            <p className="text-gray-700 mb-6">You have unsaved changes. Do you want to save the document before leaving?</p>
            <div className="flex justify-end gap-2">
              <button
                onClick={handleLeaveCancel}
                className="px-4 py-2 rounded border border-gray-300 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleLeaveDiscard}
                className="px-4 py-2 rounded border border-gray-300 hover:bg-gray-50"
              >
                Don't save
              </button>
              <button
                onClick={handleLeaveSave}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Menu;